var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddgroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 51,
    viewBox: "0 0 78 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 24,
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 25.5,
    r: 24,
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4 37.416C51.856 37.416 51.44 37.272 51.152 36.984C50.864 36.664 50.72 36.232 50.72 35.688V26.856H42.032C41.488 26.856 41.072 26.712 40.784 26.424C40.496 26.136 40.352 25.736 40.352 25.224C40.352 24.712 40.496 24.312 40.784 24.024C41.072 23.736 41.488 23.592 42.032 23.592H50.72V15.048C50.72 14.472 50.864 14.04 51.152 13.752C51.44 13.464 51.872 13.32 52.448 13.32C52.992 13.32 53.392 13.464 53.648 13.752C53.936 14.04 54.08 14.472 54.08 15.048V23.592H62.768C63.312 23.592 63.728 23.736 64.016 24.024C64.304 24.312 64.448 24.712 64.448 25.224C64.448 25.736 64.304 26.136 64.016 26.424C63.728 26.712 63.312 26.856 62.768 26.856H54.08V35.688C54.08 36.232 53.936 36.664 53.648 36.984C53.392 37.272 52.976 37.416 52.4 37.416Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddgroup);
export default __webpack_public_path__ + "static/media/addgroup.874aa5367f8723f7fa73edcba1783955.svg";
export { ForwardRef as ReactComponent };